export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const SET_ACCESS_LEVEL = "SET_ACCESS_LEVEL";
export const SET_PROFILE_NOT_FOUND = "SET_PROFILE_NOT_FOUND";
export const SET_DARK_MODE = "SET_DARK_MODE";


export const setAccessLevel = (level) => ({
    type: SET_ACCESS_LEVEL,
    payload: level,
});

export const setProfileNotFound = () => ({
    type: SET_PROFILE_NOT_FOUND,
});

export const setDarkMode = (isDarkMode) => ({
    type: SET_DARK_MODE,
    payload: isDarkMode,
});

export const userLoginRequest = () => ({
    type: USER_LOGIN_REQUEST,
});
 
export const userLoginSuccess = (payload) => ({
        type: USER_LOGIN_SUCCESS,
        payload,
});

export const userLoginError = (error) => ({
    type: USER_LOGIN_FAIL,
    payload: error,
});

export const userLogoutRequest = () => ({
    type: USER_LOGOUT_REQUEST,
});